// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3eXCK","content":"LayoutSettings_content__2si3G"};